import React from "react";
import styles from "./Repo.module.css";
import CoverComponent from "../../components/Cover/Cover";
import RepoCover from "../../images/CoverRepo.png";

const Repo = ({ lang = "BRA" }) => {
  return (
    <>
      {lang === "BRA" ? (
        <main className={styles.main}>
          <CoverComponent
            image={RepoCover}
            text="Repositório"
            height={50}
            textSize={50}
          />
          <section className={styles.listSection}>
            <ul className={styles.downloadList}>
              <li className={styles.item}>
                <span>
                  • Inequities in Access to Oncology Drugs in Brazil – the Case
                  of Public and Private Healthcare Systems
                </span>
                <a href="/downloads/BaseDadosHEMAP_ISPOR2025.xlsx" download>
                  <button className={styles.buttonLight}>
                    <div id={styles.btnPos}>
                      <span id={styles.btnText}>Baixar</span>
                    </div>
                  </button>
                </a>
              </li>
            </ul>
          </section>
        </main>
      ) : (
        <main className={styles.main}>
          <CoverComponent
            image={RepoCover}
            text="Repository"
            height={50}
            textSize={50}
          />
          <section className={styles.listSection}>
            <ul className={styles.downloadList}>
              <li className={styles.item}>
                <span>
                  • Inequities in Access to Oncology Drugs in Brazil – the Case
                  of Public and Private Healthcare Systems
                </span>
                <a href="/downloads/BaseDadosHEMAP_ISPOR2025.xlsx" download>
                  <button className={styles.buttonLight}>
                    <div id={styles.btnPos}>
                      <span id={styles.btnText}>Download</span>
                    </div>
                  </button>
                </a>
              </li>
            </ul>
          </section>
        </main>
      )}
    </>
  );
};

export default Repo;
